import { Box, Button, HStack } from '@rbilabs/universal-components';

export const IconContainer = Button.withConfig({
  variant: 'ghost',
});

export const ActionButtonsContainer = HStack.withConfig({
  flexDirection: 'row',
  justifyContent: 'space-between',
  space: '$2',
  marginTop: '$4',
});

export const ActionLinkContainer = Box.withConfig({
  flex: 1,
});
